module.exports = __webpack_public_path__ + "static/media/1-广联达新计价GCCP6.0.8186b268.png";